module.exports = __webpack_public_path__ + "img/Google.dc067887.webp";